import { Button, useLocale, ProfileSectionHeader, ProfilePageItem, ProfileField } from 'shared-ui';

import { AppMessages } from 'i18n/messages';

import { LicenseProps } from './License.types';
import * as Styled from './License.styles';

export const License = ({ license, onAddLicense }: LicenseProps) => {
  const { formatMessage } = useLocale();

  const getValidToDisplay = () => {
    if (!license?.dataWaznosci) return '-';
    if (license.isPerpetual) {
      return formatMessage({ id: AppMessages['license.perpetual'] });
    }
    return license.dataWaznosci;
  };

  return (
    <>
      <ProfileSectionHeader title={formatMessage({ id: AppMessages['license.title'] })} />

      <ProfilePageItem>
        <Styled.LicenseWrapper>
          <Styled.LicenseContainer>
            <Styled.LicenseColumn>
              <ProfileField label={formatMessage({ id: AppMessages['license.number'] })}>
                {license?.numerLicencji || '-'}
              </ProfileField>

              <ProfileField label={formatMessage({ id: AppMessages['license.validFrom'] })}>
                {license?.dataWygenerowania || '-'}
              </ProfileField>

              <ProfileField label={formatMessage({ id: AppMessages['license.maxUsers'] })}>
                {license?.maxZalogowanychUzytkownikow ?? '-'}
              </ProfileField>
            </Styled.LicenseColumn>

            <Styled.LicenseColumn>
              <ProfileField label={formatMessage({ id: AppMessages['license.licenseeName'] })}>
                {license?.nazwaLicencjobiorcy || '-'}
              </ProfileField>

              <ProfileField label={formatMessage({ id: AppMessages['license.validTo'] })}>
                {getValidToDisplay()}
              </ProfileField>
            </Styled.LicenseColumn>
          </Styled.LicenseContainer>

          {onAddLicense && (
            <Styled.ButtonContainer>
              <Button variant="contained" onClick={onAddLicense}>
                {formatMessage({ id: AppMessages['license.addLicense'] })}
              </Button>
            </Styled.ButtonContainer>
          )}
        </Styled.LicenseWrapper>
      </ProfilePageItem>
    </>
  );
};
